import { Capacitor } from "@capacitor/core";

export type AppPlatform = "web" | "ios" | "android";

/**
 * Returns the current runtime platform.
 * - 'ios' when running inside Capacitor on iOS
 * - 'android' when running inside Capacitor on Android
 * - 'web' for PWA / browser
 */
export function getPlatform(): AppPlatform {
  if (Capacitor.isNativePlatform()) {
    const p = Capacitor.getPlatform();
    if (p === "ios") return "ios";
    if (p === "android") return "android";
  }
  return "web";
}

/** Whether current platform requires Apple IAP for digital goods */
export function requiresAppleIAP(): boolean {
  return getPlatform() === "ios";
}

export function usePlatform() {
  const platform = getPlatform();
  return {
    platform,
    isIos: platform === "ios",
    isAndroid: platform === "android",
    isWeb: platform === "web",
    requiresIAP: platform === "ios",
  };
}
